<template>
  <div style="margin: 60px 0">
    <div
      style="display: flex; justify-content: space-between; align-items: center"
    >
      <div>
        <h1 style="font-size: large; font-weight: 700">Business Information</h1>
        <p style="color: #6b7280; font-size: 14px">
          View and manage seller's business details
        </p>
      </div>

      <div style="display: flex; align-items: center; gap: 16px">
        <a-button
          v-if="!isWalletLinked"
          :loading="createWalletLoading"
          @click="createWallet"
          style="border-radius: 6px; background: #26a246; color: #fff; border-color: #26a246"
          icon="wallet"
        >
          Create Wallet
        </a-button>
        <a-button
          :loading="exportLoading"
          @click="exportExcell"
          style="border-radius: 6px; background: #fff; color: #0f3659"
          icon="download"
        >
          Export
        </a-button>
      </div>
    </div>

    <!-- Business Info Cards -->
    <a-row :gutter="[24, 24]" style="margin-top: 24px">
      <!-- Account Details Card -->
      <a-col :span="12">
        <a-card
          title="Account Details"
          :bordered="true"
          style="
            height: 100%;
            min-height: 380px;
            border-radius: 12px;
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
          "
        >
          <template slot="extra">
            <a-tag color="blue">Active</a-tag>
          </template>
          <a-descriptions :column="1" :labelStyle="{ fontWeight: 'bold' }">
            <a-descriptions-item
              label="Trading Name"
              :labelStyle="{ fontWeight: 'bold' }"
            >
              {{
                (data &&
                  data.accountDetails &&
                  data.accountDetails.tradingName) ||
                "-"
              }}
            </a-descriptions-item>
            <a-descriptions-item
              label="Email"
              :labelStyle="{ fontWeight: 'bold' }"
            >
              {{
                (data &&
                  data.accountDetails &&
                  data.accountDetails.accountEmail) ||
                "-"
              }}
            </a-descriptions-item>
            <a-descriptions-item
              label="Phone"
              :labelStyle="{ fontWeight: 'bold' }"
            >
              {{
                (data &&
                  data.accountDetails &&
                  data.accountDetails.phoneNumber) ||
                "-"
              }}
            </a-descriptions-item>
            <a-descriptions-item
              label="National ID"
              :labelStyle="{ fontWeight: 'bold' }"
            >
              {{
                (data &&
                  data.accountDetails &&
                  data.accountDetails.nationalId) ||
                "-"
              }}
            </a-descriptions-item>
            <a-descriptions-item
              label="Operation Zone"
              :labelStyle="{ fontWeight: 'bold' }"
            >
              {{
                (data &&
                  data.accountDetails &&
                  data.accountDetails.operationZone) ||
                "-"
              }}
            </a-descriptions-item>
            <a-descriptions-item
              label="Wallet Status"
              :labelStyle="{ fontWeight: 'bold' }"
            >
              <StatusTag :status="getWalletStatus()" />
            </a-descriptions-item>
          </a-descriptions>
        </a-card>
      </a-col>

      <!-- Business Address Card -->
      <a-col :span="12">
        <a-card
          title="Business Address"
          :bordered="true"
          style="
            height: 100%;
            min-height: 380px;
            border-radius: 12px;
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
          "
        >
          <a-descriptions :column="1" :labelStyle="{ fontWeight: 'bold' }">
            <a-descriptions-item
              label="Address Line 1"
              :labelStyle="{ fontWeight: 'bold' }"
            >
              {{
                (data &&
                  data.businessAddress &&
                  data.businessAddress.addressLine1) ||
                "-"
              }}
            </a-descriptions-item>
            <a-descriptions-item
              label="Address Line 2"
              :labelStyle="{ fontWeight: 'bold' }"
            >
              {{
                (data &&
                  data.businessAddress &&
                  data.businessAddress.addressLine2) ||
                "-"
              }}
            </a-descriptions-item>
            <a-descriptions-item
              label="State/Region"
              :labelStyle="{ fontWeight: 'bold' }"
            >
              {{
                (data &&
                  data.businessAddress &&
                  data.businessAddress.stateRegion) ||
                "-"
              }}
            </a-descriptions-item>
            <a-descriptions-item
              label="City/Town"
              :labelStyle="{ fontWeight: 'bold' }"
            >
              {{
                (data &&
                  data.businessAddress &&
                  data.businessAddress.cityTown) ||
                "-"
              }}
            </a-descriptions-item>
          </a-descriptions>
        </a-card>
      </a-col>

      <!-- Business Details Card -->
      <a-col :span="12">
        <a-card
          title="Business Details"
          :bordered="true"
          style="
            height: 100%;
            min-height: 380px;
            border-radius: 12px;
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
          "
        >
          <a-descriptions :column="1" :labelStyle="{ fontWeight: 'bold' }">
            <a-descriptions-item
              label="Business Name"
              :labelStyle="{ fontWeight: 'bold' }"
            >
              {{
                (data &&
                  data.businessDetails &&
                  data.businessDetails.businessName) ||
                "-"
              }}
            </a-descriptions-item>
            <a-descriptions-item
              label="Business Type"
              :labelStyle="{ fontWeight: 'bold' }"
            >
              {{
                (data &&
                  data.businessDetails &&
                  data.businessDetails.businessType) ||
                "-"
              }}
            </a-descriptions-item>
            <a-descriptions-item
              label="Registration No"
              :labelStyle="{ fontWeight: 'bold' }"
            >
              {{
                (data &&
                  data.businessDetails &&
                  data.businessDetails.businessRegistrationNo) ||
                "-"
              }}
            </a-descriptions-item>
            <a-descriptions-item
              label="Tax ID"
              :labelStyle="{ fontWeight: 'bold' }"
            >
              {{
                (data &&
                  data.businessDetails &&
                  data.businessDetails.taxIdentificationNumber) ||
                "-"
              }}
            </a-descriptions-item>
            <a-descriptions-item
              label="Nature of Business"
              :labelStyle="{ fontWeight: 'bold' }"
            >
              {{
                (data &&
                  data.businessDetails &&
                  data.businessDetails.natureOfBusiness) ||
                "-"
              }}
            </a-descriptions-item>
          </a-descriptions>
          <div style="margin-top: 16px">
            <a-button
              type="link"
              @click="
                viewDocument({
                  documentType: 'Certificate of Registration',
                  documentUrl:
                    data &&
                    data.businessDetails &&
                    data.businessDetails.certificateOfRegistration &&
                    data.businessDetails.certificateOfRegistration[0],
                })
              "
              :disabled="
                !(
                  data &&
                  data.businessDetails &&
                  data.businessDetails.certificateOfRegistration &&
                  data.businessDetails.certificateOfRegistration[0]
                )
              "
            >
              <a-icon type="file" /> View Registration Certificate
            </a-button>
          </div>
        </a-card>
      </a-col>

      <!-- Payment Information Card -->
      <a-col :span="12">
        <a-card
          title="Payment Information"
          :bordered="true"
          style="
            height: 100%;
            min-height: 380px;
            border-radius: 12px;
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
          "
        >
          <a-tabs default-active-key="1">
            <a-tab-pane key="1" tab="Bank Details">
              <a-descriptions :column="1">
                <a-descriptions-item
                  label="Bank Name"
                  :labelStyle="{ fontWeight: 'bold' }"
                >
                  {{
                    (data &&
                      data.paymentInformation &&
                      data.paymentInformation.bankDetails &&
                      data.paymentInformation.bankDetails.bankName) ||
                    "-"
                  }}
                </a-descriptions-item>
                <a-descriptions-item
                  label="Account Name"
                  :labelStyle="{ fontWeight: 'bold' }"
                >
                  {{
                    (data &&
                      data.paymentInformation &&
                      data.paymentInformation.bankDetails &&
                      data.paymentInformation.bankDetails.accountName) ||
                    "-"
                  }}
                </a-descriptions-item>
                <a-descriptions-item
                  label="Account Number"
                  :labelStyle="{ fontWeight: 'bold' }"
                >
                  {{
                    (data &&
                      data.paymentInformation &&
                      data.paymentInformation.bankDetails &&
                      data.paymentInformation.bankDetails.accountNumber) ||
                    "-"
                  }}
                </a-descriptions-item>
                <a-descriptions-item
                  label="Swift Code"
                  :labelStyle="{ fontWeight: 'bold' }"
                >
                  {{
                    (data &&
                      data.paymentInformation &&
                      data.paymentInformation.bankDetails &&
                      data.paymentInformation.bankDetails.swiftCode) ||
                    "-"
                  }}
                </a-descriptions-item>
                <a-descriptions-item
                  label="IBAN"
                  :labelStyle="{ fontWeight: 'bold' }"
                >
                  {{
                    (data &&
                      data.paymentInformation &&
                      data.paymentInformation.bankDetails &&
                      data.paymentInformation.bankDetails.iban) ||
                    "-"
                  }}
                </a-descriptions-item>
              </a-descriptions>
            </a-tab-pane>
            <a-tab-pane key="2" tab="Mobile Money">
              <a-descriptions :column="1">
                <a-descriptions-item
                  label="Registered Name"
                  :labelStyle="{ fontWeight: 'bold' }"
                >
                  {{
                    (data &&
                      data.paymentInformation &&
                      data.paymentInformation.mobileMoneyDetails &&
                      data.paymentInformation.mobileMoneyDetails
                        .mobileMoneyRegisteredName) ||
                    "-"
                  }}
                </a-descriptions-item>
                <a-descriptions-item
                  label="Registered Number"
                  :labelStyle="{ fontWeight: 'bold' }"
                >
                  {{
                    (data &&
                      data.paymentInformation &&
                      data.paymentInformation.mobileMoneyDetails &&
                      data.paymentInformation.mobileMoneyDetails
                        .mobileMoneyRegisteredNumber) ||
                    "-"
                  }}
                </a-descriptions-item>
              </a-descriptions>
            </a-tab-pane>
          </a-tabs>
          <div style="margin-top: 16px">
            <a-button
              type="link"
              @click="
                viewDocument({
                  documentType: 'Proof of Payment',
                  documentUrl:
                    data &&
                    data.paymentInformation &&
                    data.paymentInformation.proofOfDocument &&
                    data.paymentInformation.proofOfDocument[0],
                })
              "
              :disabled="
                !(
                  data &&
                  data.paymentInformation &&
                  data.paymentInformation.proofOfDocument &&
                  data.paymentInformation.proofOfDocument[0]
                )
              "
            >
              <a-icon type="file" /> View Payment Proof
            </a-button>
          </div>
        </a-card>
      </a-col>

      <!-- Legal Representative Card -->
      <a-col :span="12">
        <a-card
          title="Legal Representative"
          :bordered="true"
          style="
            height: 100%;
            min-height: 380px;
            border-radius: 12px;
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
          "
        >
          <a-descriptions :column="1">
            <a-descriptions-item
              label="Full Name"
              :labelStyle="{ fontWeight: 'bold' }"
            >
              {{
                (data &&
                  data.legalRepresentationDetails &&
                  data.legalRepresentationDetails.fullName) ||
                "-"
              }}
            </a-descriptions-item>
            <a-descriptions-item
              label="Address"
              :labelStyle="{ fontWeight: 'bold' }"
            >
              {{
                (data &&
                  data.legalRepresentationDetails &&
                  data.legalRepresentationDetails.address) ||
                "-"
              }}
            </a-descriptions-item>
            <a-descriptions-item
              label="Phone Number"
              :labelStyle="{ fontWeight: 'bold' }"
            >
              {{
                (data &&
                  data.legalRepresentationDetails &&
                  data.legalRepresentationDetails.phoneNumber) ||
                "-"
              }}
            </a-descriptions-item>
          </a-descriptions>
        </a-card>
      </a-col>

      <!-- Additional Information Card -->
      <a-col :span="12">
        <a-card
          title="Additional Information"
          :bordered="true"
          style="
            height: 100%;
            min-height: 380px;
            border-radius: 12px;
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
          "
        >
          <a-descriptions :column="1">
            <a-descriptions-item
              label="Preferred Payment Terms"
              :labelStyle="{ fontWeight: 'bold' }"
            >
              {{
                (data &&
                  data.additionalInformation &&
                  data.additionalInformation.preferredPaymentTerms) ||
                "-"
              }}
            </a-descriptions-item>
            <a-descriptions-item
              label="Maximum Credit Limit"
              :labelStyle="{ fontWeight: 'bold' }"
            >
              {{
                data &&
                data.additionalInformation &&
                data.additionalInformation.maximumCreditLimitPerBuyer
                  ? `${data.additionalInformation.maximumCreditLimitPerBuyer.toLocaleString()}`
                  : "-"
              }}
            </a-descriptions-item>
            <a-descriptions-item
              label="Enable Credit to Buyers"
              :labelStyle="{ fontWeight: 'bold' }"
            >
              <a-tag
                :color="
                  data &&
                  data.additionalInformation &&
                  data.additionalInformation.enableCreditToBuyers
                    ? 'green'
                    : 'red'
                "
              >
                {{
                  data &&
                  data.additionalInformation &&
                  data.additionalInformation.enableCreditToBuyers
                    ? "Yes"
                    : "No"
                }}
              </a-tag>
            </a-descriptions-item>
            <a-descriptions-item
              label="Allow Early Payments"
              :labelStyle="{ fontWeight: 'bold' }"
            >
              <a-tag
                :color="
                  data &&
                  data.additionalInformation &&
                  data.additionalInformation
                    .allowEarlyPaymentsForApprovedCreditInvoices
                    ? 'green'
                    : 'red'
                "
              >
                {{
                  data &&
                  data.additionalInformation &&
                  data.additionalInformation
                    .allowEarlyPaymentsForApprovedCreditInvoices
                    ? "Yes"
                    : "No"
                }}
              </a-tag>
            </a-descriptions-item>
          </a-descriptions>
        </a-card>
      </a-col>
    </a-row>

    <!-- <div
      style="
        background: #f9fafb;
        border-top: 1px solid #e6e6e6;
        padding: 16px 24px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-radius: 0 0 8px 8px;
        margin: 24px 0 0 0;
        width: 100%;
        border: 1px solid #e6e6e6;
      "
    >
      <div style="display: flex; align-items: center; color: #555">
        <a-icon type="clock-circle" style="margin-right: 8px" />
        <span
          >Last updated on {{ formatDate }} by
          {{ (data && data.createdBy) || "Admin User" }}</span
        >
      </div>

      <a-button
        type="link"
        @click="viewHistory"
        style="padding: 0; color: #1890ff"
      >
        <a-icon type="history" />
        View History
      </a-button>
    </div> -->
    <DocumentPreviewModal
      :visible="previewVisible"
      :documentUrl="previewDocumentUrl"
      @close="handlePreviewCancel"
    />

    <!-- Create Wallet Modal -->
    <a-modal
      :visible="createWalletModalVisible"
      title="Create Wallet"
      :footer="null"
      @cancel="handleCreateWalletModalCancel"
      :closable="true"
      :maskClosable="true"
      width="400px"
    >
      <div style="text-align: center; padding: 20px 0;">
        <div style="margin-bottom: 20px;">
          <i class="fa fa-credit-card" style="font-size: 48px; color: #26a246;"></i>
        </div>
        <h3 style="margin-bottom: 16px; color: #000; font-weight: 600;">Create Wallet</h3>
        <p style="color: #6b7280; margin-bottom: 24px; line-height: 1.5;">
          Are you sure you want to create a wallet for {{ businessName }}? 
          This action cannot be undone.
        </p>
        <div style="display: flex; gap: 12px; justify-content: center;">
          <a-button
            :loading="createWalletLoading"
            @click="confirmCreateWallet"
            style="background: #26a246; border-color: #26a246; color: #fff; border-radius: 6px;"
          >
            Create Wallet
          </a-button>
          <a-button
            @click="handleCreateWalletModalCancel"
            style="background: #fff; border-color: #d9d9d9; color: #666; border-radius: 6px;"
          >
            Cancel
          </a-button>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { formatDate, getFileDownloadUrl } from '../../../utils';
import { mapState } from 'vuex';
import DocumentPreviewModal from "../../shared-components/DocumentPreviewModal.vue";
import StatusTag from "../../shared-components/StatusTag.vue";
import sellersService from "../../../api/sellers.service";

export default {
  name: "BusinessInfo",
  components: { DocumentPreviewModal, StatusTag },
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      exportLoading: false,
      createWalletLoading: false,
      createWalletModalVisible: false,
      previewDocumentUrl: "",
      previewVisible: false
    };
  },
  computed: {
    ...mapState('sellerManagement', ['seller']),
    formatDate,
    isWalletLinked() {
      return this.data && this.data.isWalletLinked;
    },
    businessName() {
      return this.data && this.data.businessDetails && this.data.businessDetails.businessName || 'this business';
    },
  },
  methods: {
    async exportExcell() {
      try {
        this.exportLoading = true;
        const XLSX = require("xlsx");

        // Prepare the data for export
        const exportData = {
          "Account Details": [
            {
              Field: "Trading Name",
              Value: this.data?.accountDetails?.tradingName || "-",
            },
            {
              Field: "Email",
              Value: this.data?.accountDetails?.accountEmail || "-",
            },
            {
              Field: "Phone",
              Value: this.data?.accountDetails?.phoneNumber || "-",
            },
            {
              Field: "National ID",
              Value: this.data?.accountDetails?.nationalId || "-",
            },
            {
              Field: "Operation Zone",
              Value: this.data?.accountDetails?.operationZone || "-",
            },
          ],
          "Business Address": [
            {
              Field: "Address Line 1",
              Value: this.data?.businessAddress?.addressLine1 || "-",
            },
            {
              Field: "Address Line 2",
              Value: this.data?.businessAddress?.addressLine2 || "-",
            },
            {
              Field: "State/Region",
              Value: this.data?.businessAddress?.stateRegion || "-",
            },
            {
              Field: "City/Town",
              Value: this.data?.businessAddress?.cityTown || "-",
            },
          ],
          "Business Details": [
            {
              Field: "Business Name",
              Value: this.data?.businessDetails?.businessName || "-",
            },
            {
              Field: "Business Type",
              Value: this.data?.businessDetails?.businessType || "-",
            },
            {
              Field: "Registration No",
              Value: this.data?.businessDetails?.businessRegistrationNo || "-",
            },
            {
              Field: "Tax ID",
              Value: this.data?.businessDetails?.taxIdentificationNumber || "-",
            },
            {
              Field: "Nature of Business",
              Value: this.data?.businessDetails?.natureOfBusiness || "-",
            },
          ],
          "Payment Information": [
            {
              Field: "Bank Name",
              Value: this.data?.paymentInformation?.bankDetails?.bankName || "-",
            },
            {
              Field: "Account Name",
              Value: this.data?.paymentInformation?.bankDetails?.accountName || "-",
            },
            {
              Field: "Account Number",
              Value: this.data?.paymentInformation?.bankDetails?.accountNumber || "-",
            },
            {
              Field: "Swift Code",
              Value: this.data?.paymentInformation?.bankDetails?.swiftCode || "-",
            },
            {
              Field: "IBAN",
              Value: this.data?.paymentInformation?.bankDetails?.iban || "-",
            },
          ],
          "Legal Representative": [
            {
              Field: "Full Name",
              Value: this.data?.legalRepresentationDetails?.fullName || "-",
            },
            {
              Field: "Address",
              Value: this.data?.legalRepresentationDetails?.address || "-",
            },
            {
              Field: "Phone Number",
              Value: this.data?.legalRepresentationDetails?.phoneNumber || "-",
            },
          ],
          "Additional Information": [
            {
              Field: "Preferred Payment Terms",
              Value: this.data?.additionalInformation?.preferredPaymentTerms || "-",
            },
            {
              Field: "Maximum Credit Limit",
              Value: this.data?.additionalInformation?.maximumCreditLimitPerBuyer
                ? `${this.data.additionalInformation.maximumCreditLimitPerBuyer.toLocaleString()}`
                : "-",
            },
            {
              Field: "Enable Credit to Buyers",
              Value: this.data?.additionalInformation?.enableCreditToBuyers ? "Yes" : "No",
            },
            {
              Field: "Allow Early Payments",
              Value: this.data?.additionalInformation?.allowEarlyPaymentsForApprovedCreditInvoices
                ? "Yes"
                : "No",
            },
          ],
        };

        // Create a new workbook
        const wb = XLSX.utils.book_new();

        // Add each section as a separate worksheet
        Object.entries(exportData).forEach(([sheetName, data]) => {
          const ws = XLSX.utils.json_to_sheet(data);
          XLSX.utils.book_append_sheet(wb, ws, sheetName);
        });

        // Generate the Excel file
        const fileName = `${
          (this.data &&
            this.data.businessDetails &&
            this.data.businessDetails.businessName) ||
          "Business"
        }_Business_Info_${new Date().toISOString().split("T")[0]}.xlsx`;
        XLSX.writeFile(wb, fileName);

        this.$message.success("Business information exported successfully");
      } catch (error) {
        console.error("Error exporting business information:", error);
        this.$message.error("Failed to export business information");
      } finally {
        this.exportLoading = false;
      }
    },

    viewDocument(record) {
      if (record.documentUrl) {
        this.previewDocumentUrl = getFileDownloadUrl(record.documentUrl);
        this.previewVisible = true;
      } else {
        this.$message.warning("Document not available");
      }
    },

    handlePreviewCancel() {
      this.previewVisible = false;
      this.previewDocumentUrl = "";
    },

    getWalletStatus() {
      return this.isWalletLinked ? "Active" : "Not Created";
    },

    createWallet() {
      this.createWalletModalVisible = true;
    },

    async confirmCreateWallet() {
      try {
        this.createWalletLoading = true;
        // Make API call to create Terra wallet using service
        const response = await sellersService.createSellerWallet(this.data.userSetupId);
        
        if (response.data?.code === 200) {
          this.$message.success("Terra wallet created successfully");
          
          // Close modal
          this.createWalletModalVisible = false;
          
          // Emit event to parent to refresh data
          this.$emit('status-changed');
        } else {
          this.$message.error(response.data?.message || "Failed to create wallet");
        }
        
      } catch (error) {
        console.error("Error creating wallet:", error);
        this.$message.error("Failed to create wallet. Please try again.");
      } finally {
        this.createWalletLoading = false;
      }
    },

    handleCreateWalletModalCancel() {
      this.createWalletModalVisible = false;
    },

    viewHistory() {
      // Implement view history logic
      console.log("Viewing history");
    },


  },
};
</script>

<style scoped>
/* Add any component-specific styles here */
</style>
